module.exports = __webpack_public_path__ + "static/img/purchase_tip.4a09d80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/purchase_tip.svg
// module id = v47L
// module chunks = 1